import { SIDEBAR_Z_INDEX } from 'components/Sidebar/Sidebar';

const setExternalTooltip = ({
  tooltipId,
  chart,
  tooltip,
  tooltipInnerHTML,
}) => {
  let tooltipEl = document.getElementById(tooltipId);

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = tooltipId;
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.transition = '0.3s ease';
    tooltipEl.style.zIndex = `${SIDEBAR_Z_INDEX + 1}`;

    document.body.appendChild(tooltipEl);
  }

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  tooltipEl.innerHTML = tooltipInnerHTML;

  const { top, left } = chart.canvas.getBoundingClientRect();
  const tooltipWidth = tooltipEl.offsetWidth;
  const tooltipHeight = tooltipEl.offsetHeight;

  const tooltipX = left + window.pageXOffset + tooltip.caretX;

  const tooltipY = top + window.pageYOffset + tooltip.caretY;
  const tooltipYOffset = 14;

  const spaceOnRight = window.innerWidth - tooltipX;
  const spaceOnLeft = tooltipX;

  const hasEnoughSpaceOnTheRightButNotEnoughOnTheLeft =
    spaceOnRight < tooltipWidth && spaceOnLeft >= tooltipWidth;
  const hasEnoughSpaceOnTheLeftButNotEnoughOnTheRight =
    spaceOnLeft < tooltipWidth && spaceOnRight >= tooltipWidth;

  tooltipEl.classList.remove('above', 'below', 'no-transform');
  tooltipEl.classList.add(tooltip.yAlign || 'no-transform');
  tooltipEl.style.opacity = 1;
  tooltipEl.style.top = `${tooltipY - tooltipHeight - tooltipYOffset}px`;

  if (hasEnoughSpaceOnTheRightButNotEnoughOnTheLeft) {
    tooltipEl.style.left = `${tooltipX - tooltipWidth}px`;
  } else if (hasEnoughSpaceOnTheLeftButNotEnoughOnTheRight) {
    tooltipEl.style.left = `${tooltipX}px`;
  } else {
    tooltipEl.style.left = `${Math.round(tooltipX - tooltipWidth / 2)}px`;
  }
};

export default setExternalTooltip;
